class EmotionModelHandler {
    constructor(isAzureOnline = false) {
        this.USE_MSAZURE_APP_SERVICES = true;
        // this.MSAZURE_SERVER_BASE_URL = "https://emo-ai-v2-service-f7g8a4cghdcyd9ey.canadacentral-01.azurewebsites.net";
        this.MSAZURE_SERVER_BASE_URL = "https://emoai-service-temp-dehnekctfjf5h8c0.canadacentral-01.azurewebsites.net";
        this.GATECH_SERVER_BASE_URL = "https://eai.lmc.gatech.edu/app/api";
        this.AI_SERVICE_BASE_URL = (this.USE_MSAZURE_APP_SERVICES && isAzureOnline) ? this.MSAZURE_SERVER_BASE_URL : this.GATECH_SERVER_BASE_URL;
    }

    async processImage(formData){
        try{
            console.log(this.AI_SERVICE_BASE_URL + '/process_image');
            const response = await fetch(this.AI_SERVICE_BASE_URL + '/process_image', {
                method: 'POST',
                body: formData
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`); // Handle HTTP errors
            }
    
            const responseData = await response.json();
    
            return responseData;
        } catch (error){
            console.error('Error processing the image:', error);
            throw error;
        }
    }
    
    // Method to extract and sort emotions from the response
    extractAndSortEmotionOutputs(output){
        let emotionResults = Object.keys(output).map(emotion => {
            // Convert to percentage
            const percentage = parseFloat((output[emotion] * 100).toFixed(2)); 
            return { 
                "emotion": emotion.charAt(0).toUpperCase() + emotion.slice(1), 
                "percentage": percentage 
            };
        });
        
        // Sort by percentage in descending order
        emotionResults.sort((a, b) => b.percentage - a.percentage);
        return emotionResults;
    }

    async testServerStatus() {
        try {
            const response = await fetch(this.MSAZURE_SERVER_BASE_URL + '/test', {
                method: 'GET'
            });

            if (!response.ok) {
                return false;
            }

            const message = await response.text();
            if (message != "hello status ok") {
                return false;
            }

            return true;
        } catch (error) {
            console.error('Error testing server status:', error);
            return false;
        }
    }
}

export default EmotionModelHandler;